import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import ExpansionPanelComp from '../../common/ExpansionPanelComp';
import TitolareEffBenefMorteAss from '../../anagrafica/figure/TitolareEffBenefMorteAss.js';


const styles = theme => ({
    root: {
        width: '100%',
    },
});

const mapStateToProps = state => {
    return {
    };
};

const mapDispatchToProps = dispatch => {
    console.log('#RTCFA TitolareEffBenefPanel.mapDispatchToProps.dispatch', dispatch);
    return {
    };
};



class TitolareEffBenefMortePanel extends React.Component {
    constructor(props) {
        super(props);
    };

    render() {
        const { classes, isValida, isDisabled, isExpanded } = this.props;
        let key = '';
        if(isDisabled) {
            key = 'panelMorte'
        }
        return (
            <div className={classes.root}>
                <ExpansionPanelComp titolo={'titolareEffBenefMorte'} componente={TitolareEffBenefMorteAss} isValida={isValida} isDisabled={isDisabled} isExpanded={isExpanded} key={key} /> 
            </div>
        )
    }
}

TitolareEffBenefMortePanel.propTypes = {
    classes: PropTypes.object.isRequired,
  };


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(TitolareEffBenefMortePanel));

